export default __webpack_public_path__ + "static/media/foto_05.74336fbb.jpg";